<div bsModal [config]="UiConstants.modalConfig" #importDialog="bs-modal" class="modal fade" tabindex="-1" role="dialog"
     aria-labelledby="myModalLabel"
     aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document" *ngIf="importDialogVisible">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">{{'TASK_FORM_IMPORT_DIALOG_TITLE' | translate}}</h4>
        <button type="button" class="close" (click)="closeImportDialog()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row" *ngIf="!importDnDVisible">
          <div class="col-md-4">
            <label
              class="mw-100 col-form-label form-control-label">{{'COMMON_NAME' | translate}}</label>
          </div>
          <div class="col-md-8">
            <label
              class="mw-100 col-form-label form-control-label">{{formImportModel.fileName}}</label>
          </div>
        </div>
        <div class="row" *ngIf="!importDnDVisible">
          <div class="col-md-4">
            <label
              class="mw-100 col-form-label form-control-label">{{'TASK_FORM_IMPORT_DISABLED_LABEL' | translate}}</label>
          </div>
          <div class="col-md-8">
            <label class="switch switch-text switch-info mb-0">
              <input type="checkbox" class="switch-input" [(ngModel)]="formImportModel.ignoreDisabledItems"
                     #ignoreDisabledItems="ngModel" id="ignoreDisabledItems" name="ignoreDisabledItems">
              <span class="switch-label" data-on="&#xe957;" data-off="&#xe98e;"></span>
              <span class="switch-handle"></span>
            </label>
          </div>
        </div>
        <div class="col-sm-12 p-0">
          <app-file-upload
            [uploadPath]="''"
            [uploadOnDrop]="false"
            (onFileDropped)="onImportableFormSelected($event)">
          </app-file-upload>
        </div>
        <div class="col-sm-12 mt-1 p-0" *ngIf="formImportModel.importResult">
          <div class="alert alert-success" *ngIf="formImportModel.importResult === 'SUCCESS'">
            <h4 class="alert-title">{{'ALERT_TEXT_UPLOAD_SUCCESSFUL' | translate}}</h4>
            <p>{{'ALERT_TEXT_SUCCESSFULLY_UPLOADED' | translate}}</p>
          </div>
          <div class="alert alert-danger" *ngIf="formImportModel.importResult === 'ERROR'">
            <h4 class="alert-title">{{'ALERT_TEXT_UPLOAD_FAILED' | translate}}</h4>
            <p>{{uploadGlobalErrors}}</p>
          </div>
          <div class="alert alert-danger" *ngIf="formImportModel.importResult === 'FORMAT_ERROR'">
            <h4 class="alert-title">{{'ALERT_TEXT_FILE_ERROR' | translate}}</h4>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeImportDialog()">
          {{'COMMON_BUTTON_CANCEL' | translate}}
        </button>
        <button type="button" class="btn btn-primary" (click)="importForm()"
                [disabled]="formImportModel.importResult">{{'COMMON_BUTTON_IMPORT' | translate}}
        </button>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->
